import { memo } from 'react';

/**
 * OTP Input Component
 * Displays a grid of input fields for entering verification code
 */
export const OTPInput = memo(
  ({ code, inputRefs, onInputChange, onKeyDown, onPaste, error, disabled }) => {
    return (
      <div className="grid grid-cols-6 gap-3 w-full">
        {code.map((digit, index) => (
          <input
            key={index}
            ref={(el) => {
              inputRefs.current[index] = el;
            }}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => onInputChange(index, e.target.value)}
            onKeyDown={(e) => onKeyDown(index, e)}
            onPaste={index === 0 ? onPaste : undefined}
            disabled={disabled}
            className={`bg-[#f2f4f8] h-[64px] w-full rounded-[10px] text-center font-['Roboto:Medium',sans-serif] font-medium text-[24px] border-2 outline-none transition-all ${
              error ? 'border-red-500 bg-red-50' : digit ? 'border-[#61b8e7]' : 'border-[#d1d5db]'
            } focus:border-[#61b8e7] disabled:opacity-50`}
            style={{ fontVariationSettings: "'wdth' 100" }}
          />
        ))}
      </div>
    );
  },
);

OTPInput.displayName = 'OTPInput';
